module.exports = __webpack_public_path__ + "files/5976fffdaa1b8e6eed853f3dc3ba1330.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size2-Regular.ttf
// module id = 1445
// module chunks = 59